import { useProjectSessionInit } from "lib/project-sessions/useProjectSessionInit";
import { PublishedPageRenderer } from "./PublishedPageRenderer";
import BuilderPageSpinner from "components/BuilderPageSpinner";
import { ProjectAuthPage } from "components/ProjectAuth/ProjectAuthPage";
import { CurrentProjectProvider } from "lib/context/current-project-context";
import { EmbedProvider } from "lib/context/embed-context";

export function PublishedPage(props: {
  isEmbed: boolean;
  noBackground?: boolean;
}) {
  const { data, refetch, isLoading, isRefetching } = useProjectSessionInit();

  if (isLoading || isRefetching || !data) {
    return <BuilderPageSpinner />;
  }

  if (data.authorized === false) {
    if (data.project.authType === "None") {
      throw new Error(
        'sessionInit is not authorized, but Project authType is "None"'
      );
    }

    return (
      <ProjectAuthPage
        projectId={data.project.id}
        projectAppearance={data.project.appearance}
        projectLogo={data.project.logo}
        authType={data.project.authType}
        onAuthSuccess={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <CurrentProjectProvider project={data.project}>
      <EmbedProvider embed={props}>
        <PublishedPageRenderer
          pageId={data.pageId}
          pageTitle={data.pageTitle}
          isEmbed={props.isEmbed}
        />
      </EmbedProvider>
    </CurrentProjectProvider>
  );
}
